import React from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormGroup,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

const SelectFiled = (props) => {
  const {
    field,
    form,
    label,
    placeholder,
    disable,
    options,
    handleData,
  } = props;
  const { name, value, onChange, onBlur } = field;

  const { errors, touched } = form;
  const showError = errors[name] && touched[name];

  const handleChange = (event) => {
    onChange(event);
    handleData(event.target.value);
  };

  return (
    <FormGroup>
      <InputLabel id={label}>{label}</InputLabel>
      <Select
        label={label}
        placeholder={placeholder}
        id={name}
        {...field}
        disabled={disable}
        onChange={handleChange}
        error={showError ? true : false}
      >
        {options.map((item, index) => {
          return (
            <MenuItem value={item.value} key={index}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{showError ? errors[name] : ""}</FormHelperText>
    </FormGroup>
  );
};

SelectFiled.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,

  label: PropTypes.string,
  placeholder: PropTypes.string,
  disable: PropTypes.bool,
  options: PropTypes.array,
  handleData: PropTypes.func,
};

SelectFiled.defaultProps = {
  label: "",
  placeholder: "",
  disable: false,
  options: [],
  handleData: () => {},
};

export default SelectFiled;
